import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { addPageSpecificationParameters, appendSerialisedHttpParams, ENVIRONMENT, HateoasMultipleResponseObject, PageSpecification } from '@scisys-uim/uim-common';
import { AmmunitionStock } from 'assets-model';
import { Observable } from 'rxjs';
import { AmmunitionStockServiceBase } from './ammunition-stock.service.base';


@Injectable({
  providedIn: 'root'
})
export class AmmunitionStockService extends AmmunitionStockServiceBase {
  constructor(http: HttpClient, @Inject(ENVIRONMENT) environment: any) {
    super(http, environment);
  }

  public findByFullFilters(filters: any, pageSpec?: PageSpecification, withStockCalculations: boolean = false, reduced: boolean = true): Observable<HateoasMultipleResponseObject<AmmunitionStock>> {
    var params = appendSerialisedHttpParams(filters);

    params = appendSerialisedHttpParams(reduced, 'reduced', params);

    if (pageSpec) {
      params = addPageSpecificationParameters(pageSpec, params);
    }

    if (withStockCalculations) {
      params = appendSerialisedHttpParams(withStockCalculations, 'withStockCalculations', params);
    }

    return this.deserialiseMultipleResponse(this.http.get<HateoasMultipleResponseObject<AmmunitionStock>>(this.serviceBaseUrl + (pageSpec ? '/findByFullFilters' : '/findByFullFiltersUnpaged'), {
      params: params
    }));
  }

}



